
interface EmailInterface {
  selectedJob: Job[];
}

import EmailInfo from '@/models/emailInfo';
import Job from '@/models/job';
import Vue from 'vue';
import { VueConstructor } from 'vue/types/vue';
import { bus } from '@/main';

const ModelPublishEmail = (Vue as VueConstructor<Vue & EmailInterface>).extend({
  props: {
    selectedJob: {
      type: Array,
      required: true,
    },
    origin: {
      type: String,
      required: true,
    },
    routeName: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      emailInfo: new EmailInfo(),
      initialMessage: '',
      personalMessage: '',
    };
  },

  mounted() {
    this.initializeEmailInfo();
  },

  methods: {
    initializeEmailInfo() {
      const job = this.selectedJob[0];
      this.emailInfo = new EmailInfo();
      this.emailInfo.jobId = job.id;
      this.emailInfo.senderName = 'Chris Porter';

      this.emailInfo.emailSubject =
        'Model Name: ' +
        job.parsedMetadata.ModelName +
        ', JobId: ' +
        job.id +
        ', Date: ' +
        job.createDateTime.toLocaleDateString();

      this.initialMessage =
        'A Publishing Job for ' +
        job.parsedMetadata.ModelName +
        ' has been shared with you by ' +
        this.emailInfo.senderName +
        '</br>' +
        'Link: <a href="' +
        this.origin +
        this.routeName +
        '/' +
        job.id +
        '">' +
        this.origin +
        this.routeName +
        '/' +
        job.id +
        '</a></br>' +
        'ModelName: ' +
        job.parsedMetadata.ModelName +
        '</br>' +
        'JobId: ' +
        job.id +
        '</br>' +
        'User Name: ' +
        job.parsedMetadata.UserDisplayName +
        '</br>' +
        'User Email: ' +
        (job.parsedMetadata.UserEmail ? job.parsedMetadata.UserEmail : ' Not Provided') +
        '</br>';
    },

    sendEmail() {
      this.emailInfo.emailMessage =
        this.initialMessage + (this.personalMessage ? 'Message from Sender: ' + this.personalMessage : '');
      this.$http
        .post('email', this.emailInfo)
        .then(() => {
          this.$emit('close-email-dialog');
          this.emailInfo = new EmailInfo();
        })
        .catch((error) => {
          bus.$emit('alert', 'Send email failed ', 'error', 6000, error);
        });
    },
  },
});

export default ModelPublishEmail;
